import ForgotPasswordForm from './ForgotPasswordForm';
import useForgotPassword from './useForgotPassword';

const ForgotPassword = () => {
  const {isLoading, handleSubmit, handleChange} = useForgotPassword();
  return (
    <ForgotPasswordForm
      isLoading={isLoading}
      handleSubmit={handleSubmit}
      handleChange={handleChange}
    />
  );
};

export default ForgotPassword;
